import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  description: string;
  actions?: ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ description, actions }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 3,
        mb: 4,
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
      }}
    >
      <Typography
        sx={{
          fontSize: '1.1rem',
          color: 'text.secondary',
          fontWeight: 400,
          lineHeight: 1.6,
          pl: 1.75,
          borderLeft: '3px solid',
          borderColor: 'primary.main',
          flex: 1,
          minWidth: 0,
        }}
      >
        {description}
      </Typography>
      {actions && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexShrink: 0,
            flexWrap: 'wrap',
          }}
        >
          {actions}
        </Box>
      )}
    </Box>
  );
};

export default PageHeader;
